import React from 'react'
import { useOptinsQuery } from 'gql/graphql'
import { initializeApollo } from '@gql/client'
import { PAGINA } from 'utils/queries'
import { PaginaType } from 'utils/types'
import MyAccountPreferenzeTemplate from 'components/templates/MyAccountPreferenzeTemplate/MyAccountPreferenzeTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

interface Props {
  pagina: PaginaType
}

const PreferenzePage = ({ pagina }: Props) => {
  const { data, loading, error } = useOptinsQuery()
  const optins = data?.optins

  if (error) {
    return <p>{error}</p>
  }

  return <MyAccountPreferenzeTemplate pagina={pagina} optins={optins} />
}

export const getStaticProps = NextWrapper.getStaticProps(async () => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'preferenze' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina },
    revalidate: 60 * 5,
  }
}, '/dashboard/preferenze')

PreferenzePage.loginRequired = true

export default PreferenzePage
